import { useEffect, useRef } from 'react';

const usePrevValue = <T extends unknown>(value: T) => {
  const ref = useRef<T>();

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
};

export default usePrevValue;
